export default __webpack_public_path__ + "static/media/download_methodiek_creatief denken.ebb635ba.pdf";